<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="deviceName" size="small" style="width: 280px" />
        <span v-html="deviceNameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="deviceCode" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂家：</span>
        </div>
        <el-select v-model="deviceManufacturerCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备型号：</span>
        </div>
        <el-select v-model="deviceModelCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="deviceManufacturerCode === '100061' ">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备账号：</span>
        </div>
        <el-input v-model="userName" size="small" style="width: 280px" />
      </div>

      <div class="form-line" v-if="deviceManufacturerCode === '100061' ">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备密码：</span>
        </div>
        <el-input v-model="password" type="password" size="small" style="width: 280px" />
      </div>

      <div class="form-line" v-if="showApplication">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备用途：</span>
        </div>
        <el-select v-model="application" size="small" style="width: 280px">
          <el-option v-for="item in applicationList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <!-- <div class="form-line" v-if="hasParentCode">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">所属网关：</span>
        </div>
        <el-select v-model="parentCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="parkingDeviceMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in parkingDeviceList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div> -->

      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">车场：</span>-->
        <!--</div>-->
        <!--<el-select v-model="rentCode"-->
                   <!--filterable-->
                   <!--remote-->
                   <!--reserve-keyword-->
                   <!--size="small" style="width: 280px"-->
                   <!--:remote-method="remoteMethod"-->
                   <!--placeholder="请输入关键词查询">-->
          <!--<el-option v-for="item in rentList" :key="item._value"-->
                     <!--:label="item._label" :value="item._value">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">进出类型：</span>
        </div>
        <el-select v-model="passType" size="small" style="width: 280px">
          <el-option v-for="item in passTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="location" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePersonCode" size="small" style="width: 280px" filterable remote reserve-keyword :remote-method="remoteMethod2" placeholder="请输入关键字搜索">
          <el-option v-for="item in responsiblePersonList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">下发显示屏：</span>
        </div>
        <el-select v-model="needToShow" size="small" style="width: 280px">
          <el-option v-for="item in showList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">主辅相机：</span>
        </div>
        <el-select v-model="deviceType" size="small" style="width: 280px">
          <el-option v-for="item in deviceTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="deviceType=='2'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">绑定主相机：</span>
        </div>
        <el-select v-model="mainDevicesCode" size="small" style="width: 280px" filterable remote reserve-keyword :remote-method="remoteMethod3" placeholder="请输入关键字搜索">
          <el-option v-for="item in mainDevicesList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text" style="width:100px">是否为场中场设备：</span>
        </div>
        <el-select v-model="inner" size="small" style="width: 280px">
          <el-option v-for="item in innerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text" style="width:150px">是否混进混出设备：</span>
        </div>
        <el-select v-model="multi" size="small" style="width: 280px">
          <el-option v-for="item in multiList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

<!--      <div class="form-line">
        <div class="textBox">
          <span class="line-text">绑定监控设备：</span>
        </div>
        <el-select v-model="videoCode" size="small" style="width: 280px" filterable remote reserve-keyword :remote-method="getVideoList" placeholder="请输入关键字搜索">
          <el-option v-for="item in videoList" :key="item.deviceCode"
                     :label="item.deviceName" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-confirm-next @confirm="addNext" value="添加下一项" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
import BreadCrumb from "../../../components/common/di-ding/common/bread-crumb";
import { errorHandler } from "../../../utils/errorHandler";
import InputTree from "../../../components/common/inputs/input-tree";
import { pattern } from "../../../utils/regular";
import { api } from "../../api/ParkingService";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";

export default {
  components: {
    ButtonConfirmNext,
    ButtonConfirm,
    ButtonCancel,
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb
  },
  name: "parking-device-add",
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: "智慧停车",
            name: "parking-device-management"
          },
          {
            value: "设备管理"
          }
        ]
      },
      mainTitle: "添加设备",
      subheading: "",
      deviceName: "",
      deviceCode: "",
      deviceNameVer: "<span>不超过32个字</span>",
      deviceManufacturerCode: "",
      deviceManufacturerList: [],
      deviceModelCode: "",
      deviceModelNameList: [],
      passType: "1",
      passTypeList: [
        { code: "1", name: "进" },
        { code: "2", name: "出" }
        // {code: '3', name: '进/出'},
      ],
      rentList: [],
      rentCode: "",
      hasParentCode: false,
      parkingDeviceList: [],
      parentCode: "",
      parentName: "",
      responsiblePersonCode: [],
      responsiblePersonList: [],
      deviceNameHttp: false,
      deviceCodeHttp: false,

      showApplication: false,
      application: "",
      applicationList: [
        {
          name: "抓拍司机",
          code: "1"
        },
        {
          name: "抓拍越栏",
          code: "2"
        },
        {
          name: "安全帽报警",
          code: "3"
        }
      ],
      userName: "",
      password: "",
      location: "",

      needToShow: "",
      showList: [{ code: "0", name: "不显示" }, { code: "1", name: "显示" }],
      innerList: [{ code: true, name: "是" }, { code: false, name: "否" }],
      multiList:[{ code: true, name: "是" }, { code: false, name: "否" }],
      deviceType: "",
      deviceTypeList: [
        { code: "1", name: "主相机" },
        { code: "2", name: "辅相机" }
      ],
      mainDevicesList: [],
      mainDevicesCode: "",
      inner: false,
      multi:false,

      videoCode: '',
      videoName: '',
      videoList: []
    };
  },
  created() {
    // this.deviceManufacturerCode = this.deviceManufacturerList[0].code
    // this.deviceModelCode = this.deviceModelNameList[0].code
    this.getAllDeviceManufacture();
    // this.getAllDeviceType()
    // this.getResponsiblePersonList()
    // this.getRentList()
    this.getParkingDeviceList();
    // this.getVideoList()
    // this.getResponsible();
    this.remoteMethod2();
    this.remoteMethod3();
  },
  methods: {
    remoteMethod3() {
      this.getMainDevicesList();
    },
    getMainDevicesList() {
      this.$axios
        .post(api.getMainDevicesList, {})
        .then(res => {
          this.mainDevicesList = res.data.data;
        })
        .catch(errorHandler("获取设备列表失败"));
    },

    // 获取监控设备列表
    getVideoList (query) {
      this.$axios.post(api.getVideoDeviceList, {
        searchKey: query || ''
      })
        .then(res => {
          this.videoList = res.data.data;
        })
        .catch(errorHandler("获取监控设备列表失败"));
    },

    // 获取设备列表
    getParkingDeviceList(searchKey) {
      this.$axios
        .post(api.getParkingDeviceList, {
          searchKey: searchKey || ""
        })
        .then(res => {
          let list = res.data.data;
          console.log(list);
          list.forEach(it => {
            it._value = it.code;
            it._label = it.name;
          });
          this.parkingDeviceList = list;
          // if (this.parkingDeviceList) {
          //   if (this.parkingDeviceList.length > 0) {
          //     this.parentCode = this.parkingDeviceList[0].code
          //   }
          // }
        })
        .catch(errorHandler("获取网关列表失败"));
    },
    // 获取车场列表
    getRentList(searchKey) {
      this.$axios
        .post(api.getRentList, {
          searchKey: searchKey || ""
        })
        .then(res => {
          let list = res.data.data;
          list.forEach(it => {
            it._value = it.code;
            it._label = it.name;
          });
          this.rentList = list;
          // if (this.rentList) {
          //   if (this.rentList.length > 0) {
          //     this.rentCode = this.rentList[0].code
          //   }
          // }
        })
        .catch(errorHandler("获取车场列表失败"));
    },

    remoteMethod2(query) {
      this.getResponsible(query);
    },
    // 获取责任人列表
    getResponsible(searchKey) {
      this.$axios
        .post(api.getResponsible, { searchKey: searchKey || "" })
        .then(res => {
          let list = res.data.data;
          list.forEach(it => {
            it._value = it.code;
            it._label = `${it.name} / ${it.phone}`;
          });
          this.responsiblePersonList = list;
        })
        .catch(errorHandler("获取责任人列表失败"));
    },
    getAllDeviceManufacture() {
      this.$axios
        .post(api.getAllDeviceManufacture, {
          moduleCode: "4"
        })
        .then(res => {
          let data = res.data.data;
          this.deviceManufacturerList = data;
          if (this.deviceManufacturerList.length > 0) {
            this.deviceManufacturerCode = data[0].code;
            this.getAllDeviceType();
          }
        })
        .catch(errorHandler("获取设备厂家失败"));
    },
    getAllDeviceType() {
      this.$axios
        .post(api.getAllDeviceType, {
          moduleCode: "4",
          deviceManufactureCode: this.deviceManufacturerCode
        })
        .then(res => {
          let data = res.data.data;
          this.deviceModelNameList = data;
          if (this.deviceModelNameList.length > 0) {
            this.deviceModelName = data[0].code;
          }
        })
        .catch(errorHandler("获取设备型号失败"));
    },

    parkingDeviceMethod(query) {
      this.getParkingDeviceList(query);
    },

    remoteMethod(query) {
      this.getRentList(query);
    },
    // getRoomList (v) {
    //   this.roomCode = v.code
    //   this.roomNumber = v.buildingName + v._label
    // },
    addNext() {
      if (!this.deviceName) {
        // this.deviceNameVer = '<span style="color: red;">请输入设备名称</span>';
        nError("请输入设备名称");
        return false;
      }
      if (!this.deviceCode) {
        nError("请输入设备编号");
        return false;
      }
      if (this.hasParentCode && !this.parentCode) {
        nError("请选择所属网关");
        return false;
      }
      if (this.showApplication && !this.application) {
        nError("请选择设备用途");
        return false;
      }
      if (!this.location) {
        nError("请输入设备位置");
        return false;
      }
      if (!this.responsiblePersonCode) {
        nError("请选择设备责任人");
        return false;
      }
      if (!this.needToShow) {
        nError("请选择是否下发显示屏");
        return false;
      }
      if (!this.deviceNameHttp) {
        return false;
      } else {
        this.deviceNameVer = "<span>不超过32个字</span>";
      }
      if (
        this.deviceManufacturerCode === "100061" &&
        (!this.userName || !this.password)
      ) {
        nError("请输入设备账户和密码");
        return false;
      }
      if (!this.deviceModelCode) {
        nError("请选择设备型号");
        return false;
      }
      if (!this.deviceType) {
        nError("请选择相机主辅");
        return false;
      }
      if (this.deviceType == "2" && !this.parentCode) {
        nError("请选择绑定主相机");
        return false;
      }
      let obj = {
        name: this.deviceName,
        code: this.deviceCode,
        parkingDeviceManufacturerCode: this.deviceManufacturerCode,
        parkingDeviceManufacturerName: "",
        parkingDeviceModelCode: this.deviceModelCode,
        parkingDeviceModelName: "",
        application: this.application,
        passType: this.passType,
        parkingDeviceResponsibleList: [],
        userName: this.userName,
        password: this.password,
        location: this.location,
        needToShow: this.needToShow,
        parentCode: this.parentCode,
        parentName: this.parentName,
        deviceType: this.deviceType,
        inner: this.inner,
        multi:this.multi,
        videoCode: this.videoCode,
        videoName: this.videoName,
        personName:this.personName,
        personCode:this.personCode,
      };
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturerCode) {
          obj.parkingDeviceManufacturerName = v.name;
        }
      });
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelCode) {
          obj.parkingDeviceModelName = v.name;
        }
      });
      this.responsiblePersonList.map(v => {
        if(v.code===this.responsiblePersonCode) {
          obj.personName = v.name
          obj.personCode = v.code
        }
      });
      this.videoList.map(v => {
        if (v.deviceCode === this.videoCode) {
          obj.videoName = v.deviceName;
        }
      });
      this.$axios.post(api.addParkingDevice, obj)
        .then(res => {
          if (res.data.retCode == 1) {
            nSuccess("添加成功");
            this.deviceName = "";
            this.deviceCode = "";
            this.responsiblePersonCode = "";
          }
        })
        .catch(errorHandler("添加设备失败"));
    },
    add() {
      if (!this.deviceName) {
        // this.deviceNameVer = '<span style="color: red;">请输入设备名称</span>';
        nError("请输入设备名称");
        return false;
      }
      if (!this.deviceCode) {
        nError("请输入设备编号");
        return false;
      }
      if (!this.responsiblePersonCode) {
        nError("请选择设备责任人");
        return false;
      }
      if (this.hasParentCode && !this.parentCode) {
        nError("请选择所属网关");
        return false;
      }
      if (this.showApplication && !this.application) {
        nError("请选择设备用途");
        return false;
      }
      if (!this.location) {
        nError("请输入设备位置");
        return false;
      }
      if (!this.deviceNameHttp) {
        return false;
      } else {
        this.deviceNameVer = "<span>不超过32个字</span>";
      }
      if (!this.deviceModelCode) {
        nError("请选择设备型号");
        return false;
      }
      if (
        this.deviceManufacturerCode === "100061" &&
        (!this.userName || !this.password)
      ) {
        nError("请输入设备账户和密码");
        return false;
      }
      if (!this.needToShow) {
        nError("请选择是否下发显示屏");
        return false;
      }
      if (!this.deviceType) {
        nError("请选择相机主辅");
        return false;
      }
      if (this.deviceType == "2" && !this.parentCode) {
        nError("请选择绑定主相机");
        return false;
      }
      let obj = {
        name: this.deviceName,
        code: this.deviceCode,
        parkingDeviceManufacturerCode: this.deviceManufacturerCode,
        parkingDeviceManufacturerName: "",
        parkingDeviceModelCode: this.deviceModelCode,
        parkingDeviceModelName: "",
        application: this.application,
        passType: this.passType,
        parkingDeviceResponsibleList: [],
        userName: this.userName,
        password: this.password,
        location: this.location,
        needToShow: this.needToShow,
        parentCode: this.parentCode,
        parentName: this.parentName,
        deviceType: this.deviceType,
        inner: this.inner,
        multi:this.multi,
        videoCode: this.videoCode,
        videoName: this.videoName,
        personName:this.personName,
        personCode:this.personCode,
      };
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturerCode) {
          obj.parkingDeviceManufacturerName = v.name;
        }
      });
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelCode) {
          obj.parkingDeviceModelName = v.name;
        }
      });
      this.responsiblePersonList.map(v => {
          if(v.code===this.responsiblePersonCode) {
            obj.personName = v.name
            obj.personCode = v.code
          }
      });
      this.videoList.map(v => {
        if (v.deviceCode === this.videoCode) {
          obj.videoName = v.deviceName;
        }
      });
      this.$axios.post(api.addParkingDevice, obj)
        .then(res => {
          nSuccess("添加成功");
          this.strategyCenter();
        })
        .catch(errorHandler("添加设备失败"));
    },
    strategyCenter() {
      this.$router.push({
        name: "parking-device-management"
      });
    }
  },
  watch: {
    mainDevicesCode(val) {
      this.mainDevicesList.map(v => {
        if (val == v.code) {
          this.parentCode = v.code;
          this.parentName = v.name;
        }
      });
    },
    deviceName(v) {
      let ptn = pattern.basicAndCN.test(v);
      if (!ptn) {
        this.deviceNameVer =
          '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>';
        this.deviceNameHttp = false;
      } else {
        this.deviceNameVer = "<span>不超过32个字</span>";
        this.deviceNameHttp = true;
      }
    },
    parentCode() {
      this.parkingDeviceList.map(v => {
        if (v.code === this.parentCode) {
          this.parentName = v.name;
        }
      });
    },
    deviceManufacturerCode() {
      this.getAllDeviceType();
    },
    // deviceManufacturerCode () {
    //   if (this.deviceManufacturerCode === '大华') {
    //     this.hasParentCode = true
    //     this.deviceModelNameList = [
    //       {
    //         name: 'DH-IPC-HFW5243K-ZFD-LED',
    //         code: 'DH-IPC-HFW5243K-ZFD-LED'
    //       }, {
    //         name: 'DH-ITC215-PW5H-F6',
    //         code: 'DH-ITC215-PW5H-F6'
    //       }
    //     ]
    //   } else if (this.deviceManufacturerCode === '大华檀木') {
    //     this.hasParentCode = true
    //     this.deviceModelNameList = [
    //       {
    //         name: 'NTN218CR-E',
    //         code: 'NTN218CR-E'
    //       }
    //     ]
    //   } else if (this.deviceManufacturerCode === '大麦物联') {
    //     this.hasParentCode = false
    //     this.deviceModelNameList = [
    //       {
    //         name: 'DM-IOTC01-E-01',
    //         code: 'DM-IOTC01-E-01'
    //       }, {
    //         name: 'DM-IOTC01-E-02',
    //         code: 'DM-IOTC01-E-02'
    //       }, {
    //         name: 'DM-IOTC01-E-03',
    //         code: 'DM-IOTC01-E-03'
    //       }
    //     ]
    //   }
    //   this.deviceModelCode = this.deviceModelNameList[0].code
    // },
    deviceModelCode() {
      if (this.deviceModelCode === "DH-IPC-HFW5243K-ZFD-LED") {
        this.showApplication = true;
      } else {
        this.showApplication = false;
      }
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 150px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingDevice/ParkingDeviceAdd.vue